var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccntingICn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3974_2577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3974_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 14.75H13.8943L15.3943 13.25H6.25V14.75ZM6.25 10.75H11.75V9.25H6.25V10.75ZM4 7V17H11.6442L10.1442 18.5H2.5V5.5H21.5V8.64425H20V7H4ZM22.2268 12.127C22.3038 12.2038 22.3423 12.2891 22.3423 12.3828C22.3423 12.4763 22.3038 12.5615 22.2268 12.6385L21.3845 13.4808L20.1152 12.2115L20.9578 11.3692C21.0346 11.2922 21.1198 11.2537 21.2135 11.2537C21.307 11.2537 21.3923 11.2922 21.4693 11.3692L22.2268 12.127ZM13.1538 20.4615V19.1923L19.5345 12.8115L20.8038 14.0808L14.423 20.4615H13.1538Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccntingICn);
export default __webpack_public_path__ + "static/media/AccntingICn.1d658338e2a19ee7d709555ccf134fb4.svg";
export { ForwardRef as ReactComponent };